import type { ApplicationHandoff } from '@inf-monkeys-tech/monkeys';
import { buildApplicationHandoffUrl } from '@inf-monkeys-tech/monkeys/runtime';
import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';

export interface ApplicationHandoffLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'> {
  handoff: ApplicationHandoff;
  targetPath?: string;
  targetOrigin?: string;
  children?: ReactNode;
  onActivate?: (
    handoff: ApplicationHandoff,
    event: MouseEvent<HTMLAnchorElement>,
  ) => void;
}

export function ApplicationHandoffLink({
  handoff,
  targetPath = handoff.target.path,
  targetOrigin,
  children,
  onActivate,
  ...props
}: ApplicationHandoffLinkProps) {
  const normalizedTargetOrigin = targetOrigin?.trim();
  const resolvedTargetPath = normalizedTargetOrigin
    ? new URL(targetPath, normalizedTargetOrigin).toString()
    : targetPath;

  return (
    <a
      {...props}
      href={buildApplicationHandoffUrl(resolvedTargetPath, handoff)}
      data-monkeys-handoff-id={handoff.handoffId}
      data-monkeys-handoff-source={handoff.source.product}
      data-monkeys-handoff-target={handoff.target.product}
      onClick={(event) => onActivate?.(handoff, event)}
    >
      {children}
    </a>
  );
}
